import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateCompanyGovernmentAllocationEntryFile {
  governmentAllocationId?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useUpdateCompanyGovernmentAllocationEntryFile = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: UseUpdateCompanyGovernmentAllocationEntryFile) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateCompanyGovernmentAllocationEntry'],
    mutationFn: async (file: File) => {
      const government_allocation_entry = {
        file,
      }

      await privateAxios.putForm(`/billing/government_allocation_entries/${governmentAllocationId}`, {
        government_allocation_entry,
      })
    },
    onSuccess,
    onError,
  })
}
